import { all } from 'redux-saga/effects';

import leaveToApproveWatcher from './LeaveToapprovesaga';

export default function* rootSaga(action) {
	yield all([leaveToApproveWatcher(action)]);
}
